/* Optional display preferences only. No IP address is stored or sent to a new provider. */
(() => {
  const languageKey = 'starsbooster:language';
  const visitKey = 'starsbooster:language-detected';
  const regionCurrency = Object.freeze({ US: 'USD', GB: 'GBP', CA: 'CAD', AU: 'AUD', CH: 'CHF', LI: 'CHF', JP: 'JPY', CN: 'CNY', IN: 'INR', BR: 'BRL', SG: 'SGD', HK: 'HKD', AE: 'AED', SA: 'SAR', TR: 'TRY', PL: 'PLN', SE: 'SEK', NO: 'NOK', NZ: 'NZD', KR: 'KRW', MX: 'MXN', ZA: 'ZAR' });
  const regionLanguage = Object.freeze({ DE: 'de', AT: 'de', FR: 'fr', PT: 'pt', BR: 'pt', IT: 'it', NL: 'nl', GR: 'el', PL: 'pl', SA: 'ar', AE: 'ar', EG: 'ar', JO: 'ar', IN: 'hi', JP: 'ja', CN: 'zh-CN', ES: 'es', MX: 'es', AR: 'es', CO: 'es', CL: 'es' });
  const normalize = (value) => typeof value === 'string' ? value.trim().replaceAll('_', '-').toLowerCase() : '';
  const read = (kind, key) => { try { return (kind === 'local' ? localStorage : sessionStorage).getItem(key); } catch { return null; } };
  const write = (kind, key, value) => { try { (kind === 'local' ? localStorage : sessionStorage).setItem(key, value); } catch { /* Preferences are optional. */ } };
  const findLanguage = (value, languages) => {
    const wanted = normalize(value);
    if (!wanted) return null;
    const exact = languages.find((item) => normalize(item.code) === wanted);
    if (exact) return exact;
    // Do not replace an explicitly requested Traditional Chinese script with Simplified Chinese.
    if (/^zh-(tw|hk|mo|hant)(-|$)/.test(wanted)) return null;
    return languages.find((item) => normalize(item.code).split('-')[0] === wanted.split('-')[0]) || null;
  };
  const choose = ({ country, preferences = [], suggestion, languages }) => {
    const currency = regionCurrency[country] || 'EUR';
    let language = null;
    for (const preference of preferences) {
      language = findLanguage(preference, languages);
      if (language) break;
    }
    language ||= findLanguage(suggestion, languages);
    language ||= findLanguage(regionLanguage[country], languages);
    language ||= findLanguage('en', languages);
    return { currency, language };
  };
  const destination = (location, currentRoot, targetRoot) => {
    const safeRoot = (value) => typeof value === 'string' && /^\/(?!\/)[a-zA-Z0-9/-]*$/.test(value) && !value.includes('..');
    if (!safeRoot(currentRoot) || !safeRoot(targetRoot)) return null;
    const current = currentRoot === '/' ? '' : currentRoot.replace(/\/$/, '');
    if (current && location.pathname !== current && !location.pathname.startsWith(`${current}/`)) return null;
    const path = current ? location.pathname.slice(current.length) || '/' : location.pathname;
    if (/^\/(cart|checkout|checkouts|account|challenge|localization)(\/|$)/.test(path)) return null;
    const root = targetRoot === '/' ? '' : targetRoot.replace(/\/$/, '');
    const target = new URL(`${root}${path}${location.search}${location.hash}`, location.origin);
    return target.origin === location.origin && target.href !== location.href ? target.href : null;
  };
  window.SBVisitorLocalization = Object.freeze({ choose, destination });
  const configNode = document.querySelector('[data-sb-visitor-localization]');
  let config;
  try { config = JSON.parse(configNode?.textContent || ''); } catch { return; }
  if (!Array.isArray(config.languages) || !config.languages.some((item) => normalize(item.code) === 'en' && item.primary)) return;
  let interacted = false;
  document.addEventListener('change', (event) => {
    const control = event.target.closest('[data-sb-localization]');
    if (!control) return;
    interacted = true;
    const language = findLanguage(control.value, config.languages);
    if (language) write('local', languageKey, language.code);
  }, true);
  // Never navigate away while a visitor is filling a form or making a selection.
  document.addEventListener('input', () => { interacted = true; }, { once: true, capture: true });
  document.addEventListener('pointerdown', () => { interacted = true; }, { once: true, capture: true });
  document.addEventListener('keydown', () => { interacted = true; }, { once: true, capture: true });
  if (window.Shopify?.designMode || new URLSearchParams(window.location.search).has('preview_theme_id')) return;
  if (/bot|crawler|spider|lighthouse/i.test(navigator.userAgent || '')) return;
  const currentLanguage = findLanguage(config.current, config.languages);
  const explicitLocale = currentLanguage && !currentLanguage.primary;
  const mayNavigate = () => !interacted && !explicitLocale && !read('session', visitKey);
  const applyLanguage = (language) => {
    if (!language || !mayNavigate() || normalize(language.code) === normalize(config.current)) return;
    const target = destination(window.location, config.root, language.root);
    if (!target) return;
    write('session', visitKey, '1');
    window.location.replace(target);
  };
  const savedLanguage = findLanguage(read('local', languageKey), config.languages);
  if (savedLanguage && normalize(savedLanguage.code) !== normalize(config.current) && mayNavigate()) {
    applyLanguage(savedLanguage);
    return;
  }
  const detect = async () => {
    let country = '';
    let suggestion = '';
    try {
      const endpoint = new URL(`${config.root.replace(/\/$/, '')}/browsing_context_suggestions.json`, window.location.origin);
      if (endpoint.origin !== window.location.origin) return;
      endpoint.search = '?country[enabled]=true&language[enabled]=true';
      const response = await fetch(endpoint.href, { credentials: 'same-origin', signal: AbortSignal.timeout(4000) });
      if (response.ok) {
        const data = await response.json();
        const detected = data?.detected_values?.country?.handle;
        if (typeof detected === 'string' && /^[A-Z]{2}$/.test(detected)) country = detected;
        const recommended = Array.isArray(data?.suggestions) ? data.suggestions.find((item) => item?.parts?.language?.confidence >= 0.8) : null;
        suggestion = recommended?.parts?.language?.handle || '';
      }
    } catch { /* Browser language and English/EUR are safe fallbacks. */ }
    const choices = choose({ country, preferences: navigator.languages || [navigator.language], suggestion, languages: config.languages });
    if (!window.SBDisplayMoney?.hasPreference) await window.SBDisplayMoney?.select(choices.currency, { automatic: true });
    if (!savedLanguage) applyLanguage(choices.language);
  };
  detect();
})();
